import { useCapability } from '../hooks'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import type { ReactNode } from 'react'

interface ProtectedCapabilityRouteProps {
  capability: string
  children: ReactNode
}

/**
 * A page the server guards with the same capability.
 *
 * Without this the route renders its shell and reports the server's 403 as a
 * failed fetch, which reads as an outage rather than a denial.
 */
export function ProtectedCapabilityRoute({
  capability,
  children,
}: ProtectedCapabilityRouteProps) {
  return (
    <ProtectedRoute
      allowed={useCapability(capability)}
      message="Your role does not have access to this page."
      toastId={`capability-denied-${capability}`}>
      {children}
    </ProtectedRoute>
  )
}
